module.exports = __webpack_public_path__ + "static/tovp-banner-dcbd58f0527908d9f3ada59569c26129.jpg";